"use client";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import type React from "react";

interface InformationCreateConfirmDialogProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	deliveryType?: "immediate" | "scheduled";
	scheduledDateTime?: string;
}

export default function InformationCreateConfirmDialog({
	open,
	onConfirm,
	onCancel,
	deliveryType = "immediate",
	scheduledDateTime,
}: InformationCreateConfirmDialogProps): React.ReactElement {
	const isScheduled = deliveryType === "scheduled";
	const scheduledDateFormatted = scheduledDateTime
		? new Date(scheduledDateTime).toLocaleString("ja-JP", {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
			})
		: "";

	return (
		<Dialog open={open} onClose={onCancel}>
			<DialogTitle>{isScheduled ? "お知らせの予約確認" : "お知らせの配信確認"}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{isScheduled ? (
						<>このお知らせを{scheduledDateFormatted}に予約配信しますか？</>
					) : (
						<>
							このお知らせを配信しますか？
							<br />
							配信後の編集はできません。
						</>
					)}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} color="primary">
					キャンセル
				</Button>
				<Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
					{isScheduled ? "予約する" : "配信する"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
